export default __webpack_public_path__ + "static/media/check-in.5ccfb6ff.gif";